import { useState, useEffect, useRef } from "react";

/**
 * Debounce a value. Uses JSON serialization for stable identity
 * so object/array values don't retrigger on every render.
 */
export function useDebounce<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);
  const serialized = JSON.stringify(value);
  const prev = useRef(serialized);

  useEffect(() => {
    // Skip if the serialized value hasn't actually changed
    if (prev.current === serialized) return;
    prev.current = serialized;

    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [serialized, delay]);

  return debounced;
}
